import authService, { functionalities, privileges } from '@/shared/services/AuthService';

// Relation billing settings (discount, price grid and administrative costs):
// users need read rights on draft invoices to see them and update rights to change them.
export const canSeeRelationBillingSettings = () =>
  authService.hasPermission({
    functionality: functionalities.InvoiceDraft,
    privilege: privileges.Read,
  });

export const canEditRelationBillingSettings = () =>
  authService.hasPermission({
    functionality: functionalities.InvoiceDraft,
    privilege: privileges.Update,
  });
